import { MotionValue } from "framer-motion"

export const isMotionValue = (v: any): v is MotionValue => v instanceof MotionValue
